export default "__VITE_ASSET__H$j_cHbBn4kXcdHynIag_A__"